import { bootstrapApplication } from '@angular/platform-browser';
import config from 'devextreme/core/config';
import './app/dx-options';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { AuthTokenService } from './app/core/auth-token.service';
import { setupBackendAuthNet, setupDevExpressAuth } from './app/core/devexpress-auth.setup';
import { licenseKey } from './app/core/devextreme-license';
import { captureLaunchParams } from './app/core/launch-params';
import { loadRuntimeConfig, RUNTIME_CONFIG } from './app/core/runtime-config';

config({ licenseKey });

// Order matters: capture+strip ?token= before anything can log the URL, wire
// DevExpress transports before any DX component renders, then bootstrap.
const token = AuthTokenService.captureFromUrl();
captureLaunchParams();
const dxAuthReady = setupDevExpressAuth(token);

loadRuntimeConfig()
    .then(async (cfg) => {
        await dxAuthReady;
        setupBackendAuthNet(token, cfg.apiBaseUrl);
        return bootstrapApplication(App, {
            ...appConfig,
            providers: [{ provide: RUNTIME_CONFIG, useValue: cfg }, ...appConfig.providers],
        });
    })
    .catch((err) => console.error(err));
